var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.registros,"hide-default-footer":"","no-data-text":_vm.$t('message.nao_ha_conteudo')},scopedSlots:_vm._u([{key:"item.linha",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.linha)+" ")]}},{key:"item.descricao",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.descricao)+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }